const ADMIN = 1
const MANAGER = 2
const SUPERVISOR = 3
const ATTENDANT = 4
const TOKEN_KEY = '@softlabPass:token'
const UNIDADES_KEY = '@softlabPass:unidades'

export { ADMIN, MANAGER, SUPERVISOR, ATTENDANT, TOKEN_KEY, UNIDADES_KEY }
